import {
    faAddressBook,
    faSearch,
    faUserCircle,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import Divider from '../../../components/Divider';
import Input from '../../../components/Input';
import { fetchContactLawyer } from '../../../services/contactLawyerService';
import UserType from '../../../types/UserType';
import styles from './style.module.scss';

function Contacts() {
    const [contacts, setContacts] = useState<UserType[]>([]);

    const { data: contactsList } = useQuery({
        queryKey: ['contacts'],
        queryFn: async () => {
            try {
                const { data } = await fetchContactLawyer();
                setContacts(data || []);
                return data || [];
            } catch (error) {
                console.error(error);
            }
            return [];
        },
    });

    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        const searchTerm = e.target.value.toLowerCase();

        if (contactsList) {
            if (searchTerm.length > 0) {
                const filteredContacts =
                    contactsList?.filter(
                        (contactItem: UserType) =>
                            contactItem.firstName
                                .toLowerCase()
                                .includes(searchTerm) ||
                            contactItem.lastName
                                .toLowerCase()
                                .includes(searchTerm) ||
                            contactItem.email.toLowerCase().includes(searchTerm)
                    ) || [];
                setContacts(filteredContacts);
            } else {
                setContacts(contactsList);
            }
        }
    };

    return (
        <div className={styles.container}>
            <h1 className={styles.title}>
                <span className={styles.headerIcon}>
                    <FontAwesomeIcon icon={faAddressBook} />
                </span>
                Contacts
            </h1>
            <Divider marginBottom="20px" />
            <div className={styles.search}>
                <Input
                    type="text"
                    placeholder="Contact..."
                    onChange={handleSearch}
                    icon={faSearch}
                />
            </div>
            <div className={styles.contacts}>
                {contacts?.map((contact: UserType) => (
                    <Link
                        key={contact.id}
                        className={styles.contact}
                        to={`${contact.id}`}
                    >
                        <FontAwesomeIcon
                            icon={faUserCircle}
                            className={styles.icon}
                        />
                        <div className={styles.details}>
                            <span className={styles.name}>
                                {contact.firstName} {contact.lastName}
                            </span>
                            <span className={styles.email}>
                                {contact.email}
                            </span>
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
}

export default Contacts;
